import React from 'react';

const SvgEarth = (props: any) => (
    <svg viewBox="0 0 15 12.93" {...props}>
        <path fill={props.fill}
              d="m9.27,8.79h0l-1.42,1.42v-2.85l1.42,1.42Zm-1.42-6.39h0l1.42,1.39-1.42,1.39v-2.77Zm2.93,1.42L6.81-.18v5l-1.81-1.81-.77.77,2.5,2.46-2.5,2.43.77.77,1.81-1.73v5.04l3.97-3.96-2.5-2.54,2.5-2.43Z"/>
    </svg>
);

export default SvgEarth;